import { Amount } from '@mews-commander/types';
import { Highlight, Icon, IconName, Size, Stack } from '@optimus-web/core';
import { LocalizedCurrencyValue } from '@mews/framework';

type AmountSize = Exclude<Size, 'extraLarge'>;

interface AmountDueProps {
    value: Amount;
    isNegative: boolean;
    size?: AmountSize;
}

const AmountDue = ({ value, isNegative, size = 'small' }: AmountDueProps) => (
    <Stack spacing="50">
        {isNegative ? <Icon value={IconName.Return} /> : null}
        <Highlight size={size}>
            <LocalizedCurrencyValue value={value} data-test-amount />
        </Highlight>
    </Stack>
);

export default AmountDue;
